import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {Link, useLocation} from 'react-router-dom';
import LoginCredentials from '../../common/component/form/LoginCredentials';
import accountApi from '../api/accountApi';
import ErrorCode from '../../common/enums/ErrorCode';

function AccountConfirmation() {
    const [t] = useTranslation();
    const {search} = useLocation();
    const [success, setSuccess] = useState(false);
    const [errorCode, setErrorCode] = useState();
    const [show, setShow] = useState(false);

    const query = new URLSearchParams(search);
    const confirmationToken = query.get('confirmationToken');
    const passwordResetToken = query.get('passwordResetToken');
    const email = query.get('email');
    const [infoText, setInfoText] = useState('Confirmation.INFO_ACTIVATION');

    const [account, setAccount] = useState(null);
    const [password, setPassword] = useState({
        password: null,
        passwordRepeat: null
    });
    const [isValidated, setIsValidated] = useState(false);
    const [validation, setValidation] = useState({
        password: true,
        passwordRepeat: true
    });

    useEffect(() => {
        accountApi.confirmAccount(confirmationToken, email).then(res => {
            if (res.data.success) {
                setSuccess(true);
                setAccount(res.data.result);
                if (res.data.result && !res.data.result.hasPassword) {
                    setInfoText('Confirmation.INFO_BEFORE_PASSWORD_RESET');
                }
            } else {
                setSuccess(false);
                setErrorCode(res.errorCode ? res.errorCode : null);
            }
        }).catch(() => {
            setSuccess(false);
        });
    }, []);

    useEffect(() => setShow(true), [success]);

    useEffect(() => {
        if (isValidated) {
            validate();
        }
    }, [password]);

    function handlePasswordChange(field, value) {
        setPassword({
            ...password,
            [field]: value
        });
    }

    function savePassword() {
        if (validate()) {
            accountApi.passwordReset(passwordResetToken, email, password.password).then((res) => {
                if (res.data.success) {
                    setAccount(res.data.result);
                    setInfoText('Confirmation.INFO_AFTER_PASSWORD_RESET');
                } else {
                    setSuccess(false);
                }
            }).catch(() => {
                setSuccess(false);
            });
        }
    }

    function validate() {
        const newValidation = {
            password: !!password.password,
            passwordRepeat: !!password.passwordRepeat && password.password === password.passwordRepeat
        };
        setIsValidated(true);
        setValidation(newValidation);

        // Check if password is valid
        return Object.values(newValidation).every(field => !!field);
    }

    return (
        <>
            <div className="login-wrapper">
                <div className="mr-4 ml-4">
                    <div className="card">
                        <div className="card-body big-label">
                            <h1>{t('Confirmation.TITLE')}</h1>
                            {show &&
                            <>
                                {
                                    success ?
                                        <>
                                            <>
                                                <p className="text-center mx-auto" style={{maxWidth: '500px'}}>{t(infoText)}</p>
                                                <div className="text-center">
                                                    {
                                                        account && account.hasPassword &&
                                                        <Link to="/login" className="btn btn-primary">{t('Confirmation.GO_TO_LOGIN')}</Link>
                                                    }
                                                </div>
                                            </>
                                            {
                                                account && !account.hasPassword &&
                                                <div className="mt-5">
                                                    <LoginCredentials
                                                        account={password}
                                                        onChange={handlePasswordChange}
                                                        validation={validation}
                                                        passwordReset={true}/>

                                                    <div className="button-footer mb-4 mr-3">
                                                        <button className="btn btn-primary" onClick={savePassword}>{t('Button.SAVE')}</button>
                                                    </div>
                                                </div>
                                            }
                                        </>
                                        :
                                        <>
                                            {
                                                (errorCode === ErrorCode.ACCOUNT_ALREADY_CONFIRMED.code) &&
                                                <>
                                                    <p className="text-center mx-auto" style={{maxWidth: '500px'}}>{t('Confirmation.ACCOUNT_ALREADY_CONFIRMED')}</p>
                                                    <div className="text-center">
                                                        <Link to="/login" className="btn btn-primary">{t('Confirmation.GO_TO_LOGIN')}</Link>
                                                    </div>
                                                </>
                                            }
                                            {
                                                (errorCode === ErrorCode.WRONG_TOKEN.code) &&
                                                <>
                                                    <p className="text-center mx-auto" style={{maxWidth: '500px'}}>{t('Error.WRONG_TOKEN')}</p>
                                                </>
                                            }

                                        </>
                                }

                            </>
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default AccountConfirmation;
